import Pin from '@/components/Icons/Pin';
import useTranslation from '@/hooks/useTranslation';
import type { FCl } from 'react-fc';
import { Badge } from '../../Atoms/Badge/Badge';

export const ContentPin: FCl = ({ className }) => {
    const { t } = useTranslation();

    return <Badge className={className} text={t('common:Labels.featured')} colorVar={'green'} icon={<Pin />} />;
};
